window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Utility collection of connection related functions.
 *
 * @return {Object} Public methods of o_util.connection.
 */
o_util.connection = (function(w) {
    "use strict";

    /**
     * Returns the Page Load Type.
     * Use o_util.connection. Prefix for all Functions below, so mocking is working as expected
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigation
     * @return {number}
     */
    function getConnectionType() {
        return (w.performance && w.performance.navigation && "type" in w.performance.navigation) ?
            w.performance.navigation.type :
            255;
    }

    /**
     * Checks wether it was a normal Page Load
     * @return {boolean}
     */
    function isNormalNavigation() {
        return o_util.connection.getConnectionType() === 0;
    }

    /**
     * Checks wether it was a Page Reload
     * @return {boolean}
     */
    function isReloadNavigation() {
        return o_util.connection.getConnectionType() === 1;
    }

    /**
     * Checks wether it was a Page Reload
     * @return {boolean}
     */
    function isForwardBackwardNavigation() {
        return o_util.connection.getConnectionType() === 2;
    }

    /**
     * Return public API.
     */
    return {
        "getConnectionType": getConnectionType,
        "isNormalNavigation": isNormalNavigation,
        "isReloadNavigation": isReloadNavigation,
        "isForwardBackwardNavigation": isForwardBackwardNavigation
    };
}(window));
